import React, { useEffect, useRef } from 'react';
import './TrustedBy.css';

const companies = [
  { name: 'Company A', logo: 'https://via.placeholder.com/150', description: 'Trusted for global brand identity development.' },
  { name: 'Company B', logo: 'https://via.placeholder.com/150', description: 'Renowned for its customized printing solutions.' },
  { name: 'Company C', logo: 'https://via.placeholder.com/150', description: 'Leading in innovative branding solutions.' },
  { name: 'Company D', logo: 'https://via.placeholder.com/150', description: 'Pioneers in premium packaging and design.' },
  { name: 'Company E', logo: 'https://via.placeholder.com/150', description: 'Providing top-tier business cards and promotional prints.' },
  { name: 'Company F', logo: 'https://via.placeholder.com/150', description: 'Experts in digital marketing strategies.' },
  { name: 'Company G', logo: 'https://via.placeholder.com/150', description: 'Specialists in custom merchandise solutions.' },
  { name: 'Company H', logo: 'https://via.placeholder.com/150', description: 'Trusted for event branding and collateral.' },
  { name: 'Company I', logo: 'https://via.placeholder.com/150', description: 'Innovators in sustainable packaging options.' },
];

const TrustedBy = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' }); // Adjust the scroll amount as needed
      }
    }, 2000); // 2000 ms = 2 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="trusted-section">
      <h2 className="trusted-title">More than 5k Top Global Brands Trust our Services</h2>
      <div className="company-grid" ref={scrollRef}>
        {companies.map((company, index) => (
          <div key={index} className="company-card">
            <img src={company.logo} alt={company.name} className="company-logo" />
            <h3 className="company-name">{company.name}</h3>
            <p className="company-description">{company.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustedBy;
